import { useEffect, useState } from "react";

import { ApiConnector } from "../../api/api-connector";
import { MonitoringAssignments } from "./monitoring-assignments";

/**
 * Loads the physician → monitoring-users mapping once per page mount.
 * `MonitoringAssignments.init` self-gates on monitoring access and swallows
 * failures, so consumers can render unconditionally.
 */
export function useMonitoringAssignments(
  api: ApiConnector,
): MonitoringAssignments {
  const [assignments] = useState(() => new MonitoringAssignments(api));

  useEffect(() => {
    void assignments.init();
  }, [assignments]);

  return assignments;
}
